import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { combineLatest, fromEvent, Observable } from "rxjs";

@UntilDestroy()
@Component({
    selector: "app-normal-layout",
    templateUrl: "./normal-layout.component.html",
    styleUrls: ["./normal-layout.component.scss"]
})
export class NormalLayoutComponent implements OnInit {
    private resizeObservable$: Observable<Event> = new Observable<Event>();
    private orientationChangeObservable$: Observable<Event> = new Observable<Event>();

    constructor() {}

    ngOnInit() {
        this.setupViewableContainerCssVar();
        this.resizeObservable$ = fromEvent(window, "resize");
        this.orientationChangeObservable$ = fromEvent(window, "orientationchange");

        combineLatest<Event[]>([this.orientationChangeObservable$, this.resizeObservable$])
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.setupViewableContainerCssVar();
            });
    }

    private setupViewableContainerCssVar() {
        const rootEl = document.documentElement;

        const footer = document.querySelector(".footer");

        const footerHeight = footer?.getBoundingClientRect().height || 0;
        const contentHeight = window.innerHeight - footerHeight;
        rootEl.style.setProperty("--content-height", contentHeight + "px");
    }
}
